import React from 'react';
import {FormikProps} from 'formik';
import {useIntl} from 'react-intl';
import {Form} from 'react-bootstrap';
import {RadioCheckInput} from '../../app/interfaces/Forms';

interface Props<T> {
  name: keyof T & string;
  label: string;
  formik: FormikProps<T>;
  options: RadioCheckInput<string>[];
  inline?: boolean;
}

function RadioInputFormik<T extends Record<string, any>>({
  label,
  name,
  formik,
  options,
  inline = false,
}: Props<T>) {
  const intl = useIntl();

  const touched = formik.touched[name];
  const errors = formik.errors[name];

  const getErrorMessage = () => {
    if (!errors) return '';
    if (typeof errors === 'string') return errors;
    if (Array.isArray(errors)) return errors.join(', ');
    return '';
  };

  return (
    <fieldset className="border-0 p-0 m-0">
      <legend className="fs-5 required" style={{fontWeight: 600}}>
        {intl.formatMessage({id: label})}
      </legend>
      <div className={inline ? 'row' : ''}>
        {options.map(({label, value, description}, index) => {
          return (
            <div className={inline ? 'col-md-6 mb-2' : 'mb-2'} key={index}>
              <Form.Check type="radio">
                <Form.Check.Input
                  id={name + '_' + value}
                  name={name}
                  type="radio"
                  value={value}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  onReset={formik.handleReset}
                  checked={formik.values[name] === value}
                />

                <Form.Check.Label
                  htmlFor={name + '_' + value}
                  className="fs-6"
                  style={{color: '#3f4254'}}
                >
                  {intl.formatMessage({id: label})}
                </Form.Check.Label>
              </Form.Check>
              {description && (
                <div className="text-muted fs-7 ms-6">
                  {intl.formatMessage({id: description})}
                </div>
              )}
            </div>
          );
        })}
      </div>
      {touched && errors && (
        <div className="fv-plugins-message-container">
          <div className="fv-help-block">
            <span role="alert">{getErrorMessage()}</span>
          </div>
        </div>
      )}
    </fieldset>
  );
}

export default RadioInputFormik;
